import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  updateStripeKeyRequest: ['secretKey'],
  updateStripeKeySuccess: null,
  updateStripeKeyFailure: ['error']
})

export const AdminTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  error: null,
  success: false
})

/* ------------- Selectors ------------- */
export const AdminSelectors = {
  selectFetching: state => state.admin.fetching,
  selectError: state => state.admin.error,
  selectSuccess: state => state.admin.success
}

/* ------------- Reducers ------------- */

export const updateStripeKeyRequest = (state) => {
  return state.merge({
    fetching: true,
    error: null,
    success: false
  })
}

export const updateStripeKeySuccess = (state) => {
  return state.merge({
    fetching: false,
    error: null,
    success: true
  })
}

export const updateStripeKeyFailure = (state, action) => {
  const { error } = action
  return state.merge({
    fetching: false,
    error,
    success: false
  })
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_STRIPE_KEY_REQUEST]: updateStripeKeyRequest,
  [Types.UPDATE_STRIPE_KEY_SUCCESS]: updateStripeKeySuccess,
  [Types.UPDATE_STRIPE_KEY_FAILURE]: updateStripeKeyFailure
})
